<template>
  <main>
    <div
      class="entry-block"
      :class="{
        'entry-block-first-change-password':
          this.$route.name === 'FirstChangePassword' ||
          this.$route.name === 'ResetPassword'
      }"
    >
      <div class="entry-block__right">
        <div class="entry-block__header">
          <router-link :to="{ name: 'HomePage' }" class="entry-block__logo">
            <!-- <img src="/images/smart-campus-logo.svg" alt=""> -->
            <img src="/images/smart-campus-logo.svg" alt="" />
          </router-link>
        </div>

        <slot />

        <ul class="langs">
          <!-- <li class="langs__item">
                        <a href="" class="langs__item-link">
                            <img src="/images/russialanguage.svg" alt="">
                        </a>
                    </li> -->
          <li class="langs__item active">
            <a href="" class="langs__item-link">
              <img src="/images/hebrewlanguage.svg" alt="" />
            </a>
          </li>
        </ul>
      </div>
      <div class="entry-block__left">
        <SingInAnimation
          v-if="$route.name === 'SignIn'"
          :animationOptions="loginOptions"
          id="bm"
        />
        <template v-else-if="$route.name === 'ForgotPassword'">
          <div id="topAnimation">
            <SingInAnimation :animationOptions="ForgotPasswordDogFullHD" />
            <SingInAnimation :animationOptions="ForgotPasswordDog" />
          </div>
          <div id="botAnimation">
            <SingInAnimation :animationOptions="ForgotPasswordGirl" />
          </div>
        </template>
        <template v-else-if="$route.name === 'Confirm'">
          <div class="sky"></div>
          <img class="bushes-1" src="/images/Bushes.svg" alt="" />
          <div id="confirmAnimation">
            <SingInAnimation :animationOptions="ConfirmAnimation" />
          </div>
          <img class="bushes-2" src="/images/Bushes.svg" alt="" />
          <div class="ground"></div>
        </template>
        <template v-else>
          <div class="entry-block__left-bg">
            <img src="/images/entry-block-bg.svg" alt="" />
          </div>
          <div class="entry-block__content">
            <h1 class="entry-block__title">
              <span>להרגיש</span>
              <span>את העוצמה</span>
              <span>של הקדמה</span>
            </h1>
            <div class="entry-block__text">
              <p>מערכת פשוטה המאגדת את כל ניהול המוסד</p>
              <p>במקום אחד</p>
            </div>
          </div>
        </template>
      </div>
    </div>
  </main>
</template>
<script>
import sing_in from '@/Components/Layout/jsons/sign_in.json';
import ForgotPasswordDog from '@/Components/Layout/jsons/ForgotPasswordDog.json';
import ForgotPasswordDogFullHD from '@/Components/Layout/jsons/ForgotPasswordDogFullHD.json';
import ForgotPasswordGirl from '@/Components/Layout/jsons/ForgotPasswordGirl.json';
import ConfirmAnimation from '@/Components/Layout/jsons/ConfirmAnimation.json';
import SingInAnimation from '@/Components/Layout/Animations/SingInAnimation';

export default {
  name: 'AuthLayout',
  components: {
    SingInAnimation
  },
  data() {
    return {
      loginOptions: { animationData: sing_in },
      ForgotPasswordGirl: { animationData: ForgotPasswordGirl },
      ForgotPasswordDogFullHD: { animationData: ForgotPasswordDogFullHD },
      ForgotPasswordDog: { animationData: ForgotPasswordDog },
      ConfirmAnimation: { animationData: ConfirmAnimation },
      animationSpeed: 1
    };
  }
};
</script>
